export default __webpack_public_path__ + "static/media/ks-motels-limited2.6b6a87ad.jpg";